module.exports = __webpack_public_path__ + "img/icon_1_7.0331f811.png";